var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import * as React from "react";
import { renderMarketsCountLink } from "../EventCard/RenderMethods";
import * as RenderMethods from "./RenderMethods";
import { getOutrightCountLinkParams, getCardDetailsParams } from "../../../../helpers";
import { observer } from "mobx-react";
let LiveOutright = class LiveOutright extends React.Component {
    /* istanbul ignore next */
    /* super transpiles to  var _this = _super.call(this) || this; */
    constructor(props) {
        super(props);
        this.renderDetails = RenderMethods.renderOutrightDetails;
        this.renderMarkets = RenderMethods.renderOutrightMarkets;
        this.getCardDetailsParams = getCardDetailsParams;
        this.getCountLinkParams = getOutrightCountLinkParams;
        this.componentPrefix = "live-outright";
        this.buttonsHolderClass = `rj-ev-list__${this.componentPrefix}__buttons-holder`;
    }
    render() {
        return (React.createElement("div", { className: `rj-ev-list__${this.componentPrefix}`, "data-uat": `div-ev-list-${this.componentPrefix}` },
            React.createElement("div", { className: `rj-ev-list__${this.componentPrefix}__inner`, "data-uat": `div-ev-list-${this.componentPrefix}-inner` },
                this.renderDetails(this.getCardDetailsParams(this.props), this.componentPrefix),
                this.renderMarkets(this.props, this.buttonsHolderClass, this.componentPrefix),
                renderMarketsCountLink(this.getCountLinkParams(this.props), this.componentPrefix))));
    }
};
LiveOutright = __decorate([
    observer,
    __metadata("design:paramtypes", [Object])
], LiveOutright);
export { LiveOutright };
//# sourceMappingURL=LiveOutright.js.map